<template>
  	<div class="bg-register">
		<img class="logo" src="../assets/img/logo_blanco.png" alt="">
		<div class="row">
			<div class="d-none d-sm-block col-md-7 avatar-register">
				<img src="../assets/img/avatar_registro.png" alt="">
			</div>
			<div class="col-md-5">
				<div class="card">
					<form @submit.prevent="login" class="form-register" action="">
						<h3 class="text-center">Inicia Sesión</h3>
						<div class="form-group">
							<input type="text" class="form-control" placeholder="Número empleado" v-model="form.code">
							<i class="fa fa-hashtag" aria-hidden="true"></i>
						</div>
						<div class="form-group">
							<input type="text" class="form-control" placeholder="Correo eléctronico" v-model="form.email">
							<i class="fa fa-at" aria-hidden="true"></i>
						</div>
						<div class="form-group">
							<button class="btn btn-bbva" type="submit" >ENTRAR</button>
						</div>
						<div>
							<router-link :to="{name: 'Register'}">No tienes cuenta? Regístrate</router-link>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import users from '../services/users'
export default {
	name: 'Home',
	data() {
		return {
			form: {
				code: '',
				email: '',
			}
		}
	},
	methods: {
		async login() {
			const vm = this
			let user = await users.loginUser(this.form)

			if(user.hasOwnProperty('error')) {
				vm.$snotify.error(user.error)
			}
		}
	}
}
</script>
